export default __webpack_public_path__ + "static/media/tutorial-get-reviews.ab59a674.gif";